import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'tr'>

/**
 * 基本的なTrコンポーネント
 */
export const BasicTr: FC<Props> = ({ children, className, ...props }) => {
  return (
    <tr {...props} className={clsx(['border-b border-b-neutral-4', className])}>
      {children}
    </tr>
  )
}
